import automationInterfaceApi from "~/api/automation_interface";
import automationResultApi from "~/api/automation_result";
import automationApi from "~/api/automation";
import globalAutomationApi from "~/api/global_automation";
import globalAutomationConfigurationApi from "~/api/global_automation_configuration";
import AutomationableTypeEnum from "~/pages/automation/enums/AutomationableTypeEnum";

const fetchConfiguredAutomationInterface = ({ commit }, { id, type }) => {
  let promise;
  if (type === AutomationableTypeEnum.GLOBAL_AUTOMATION) {
    promise = automationInterfaceApi.fetchConfiguredByGlobal(id);
  } else {
    promise = automationInterfaceApi.fetchConfigured(id);
  }
  promise.then((response) => {
    commit("SET_CONFIGURED_AUTOMATION_INTERFACE", response.data);
    commit("SET_AUTOMATION_INTERFACE_ID", response.data.id);
    commit("SET_LOADED_AUTOMATION_INTERFACE", true);
  });
};
const clearConfiguredAutomationInterface = ({ commit }) => {
  commit("SET_CONFIGURED_AUTOMATION_INTERFACE", null);
  commit("SET_AUTOMATION_INTERFACE_ID", null);
  commit("SET_LOADED_AUTOMATION_INTERFACE", false);
};
const fetchAutomationResultsByAutomation = ({
  commit,
  state,
}, {
  automation, page, perPage, name,
}) => {
  // TODO refactor to fetching/caching by automation id
  if (state.fetchingAutomationResults === false) {
    commit("SET_AUTOMATION_RESULTS", []); // can be removed when grouped by automation

    commit("SET_FETCHING_AUTOMATION_RESULTS", true);

    return automationResultApi
      .paginateByAutomation(automation.id, page, perPage, name)
      .then((response) => {
        commit("SET_AUTOMATION_RESULTS_PAGINATION", response.meta?.pagination);
        commit("SET_AUTOMATION_RESULTS", response.data);
      })
      .finally(() => {
        commit("SET_FETCHING_AUTOMATION_RESULTS", false);
      });
  }

  return Promise.resolve();
};

const fetchAutomationResultsByGlobalAutomationConfiguration = ({
  commit,
  state,
}, {
  globalAutomationConfigurationId, page, perPage, name,
}) => {
  // TODO refactor to fetching/caching by global automation configuration id
  if (state.fetchingAutomationResults === false) {
    commit("SET_AUTOMATION_RESULTS", []); // can be removed when grouped by global automation configuration

    commit("SET_FETCHING_AUTOMATION_RESULTS", true);

    return automationResultApi
      .paginateByGlobalAutomationConfiguration(globalAutomationConfigurationId, page, perPage, name)
      .then((response) => {
        commit("SET_AUTOMATION_RESULTS_PAGINATION", response.meta?.pagination);
        commit("SET_AUTOMATION_RESULTS", response.data);
      })
      .finally(() => {
        commit("SET_FETCHING_AUTOMATION_RESULTS", false);
      });
  }

  return Promise.resolve();
};

/**
 * @deprecated
 */
const fetchSearchablesByGlobalAutomation = ({ commit }, {
  globalAutomation, page, perPage, name,
}) => globalAutomationApi
  .paginateSearchablesByGlobalAutomation(globalAutomation.id, page, perPage, name)
  .then((response) => {
    commit("SET_SEARCHABLES", response.data);
    commit("SET_SEARCHABLES_PAGINATION", response.meta?.pagination);
  });

const fetchSearchablesByGlobalAutomationConfiguration = ({ commit }, {
  globalAutomationConfigurationId, page, perPage, name,
}) => globalAutomationConfigurationApi
  .paginateSearchables(globalAutomationConfigurationId, page, perPage, name)
  .then((response) => {
    commit("SET_SEARCHABLES", response.data);
    commit("SET_SEARCHABLES_PAGINATION", response.meta?.pagination);
  });

const fetchSearchablesByAutomation = ({ commit }, {
  automation, page, perPage, name,
}) => automationApi.paginateSearchablesByAutomation(automation.id, page, perPage, name)
  .then((response) => {
    commit("SET_SEARCHABLES", response.data);
    commit("SET_SEARCHABLES_PAGINATION", response.meta?.pagination);
  });
export default {
  fetchSearchablesByAutomation,
  clearConfiguredAutomationInterface,
  fetchSearchablesByGlobalAutomation,
  fetchSearchablesByGlobalAutomationConfiguration,
  fetchAutomationResultsByAutomation,
  fetchAutomationResultsByGlobalAutomationConfiguration,
  fetchConfiguredAutomationInterface,
};
